export default {"src":"/_next/static/media/IconSuzuki.d45bd561.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};